// ABOUTME: Explainer for one scanstatus column — what the bucket means and which carriers land in it.
// ABOUTME: The carriers come from the report response and are drawn with their own logo and colours.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import ExplainerModal from "../../../../theme/Modal/ExplainerModal/ExplainerModal";
import ExplainerBox from "../../../../theme/Modal/ExplainerModal/ExplainerBox";
import Text from "../../../../theme/text/Text";
import { getShipperColorSettingsByType } from "../../../../Streams/StreamShipperSettings";
import { getShipperLogo } from "../../../../../utils/logomapper";
import { scan_statuses } from "../../../../../utils/staticEnums";

const EMScanStatus = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const meta = props.meta;
    if (!meta) return null;

    // "Geen scaninfo" holds the carriers that never report a scan; the other three are outcomes for the
    // carriers that do. Which side a carrier falls on is decided by the backend, never guessed here.
    const wantsUntrackable = meta.key === scan_statuses.NO_SCAN_INFO;
    const carriers = (props.shippers || []).filter(s => Boolean(s.trackable) !== wantsUntrackable);

    return (
        <ExplainerModal>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

                <ExplainerBox
                    variant={meta.alarming ? "red" : null}
                    title={t(meta.key)}
                    text={meta.ruleKey}
                />

                <ExplainerBox
                    text={meta.detailKey}
                />

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Text bold>
                        {t(wantsUntrackable ? "scanstatus_carriers_untracked" : "scanstatus_carriers_tracked")}
                    </Text>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {carriers.map((carrier) => {
                            const shipperColors = getShipperColorSettingsByType(carrier.type);
                            return (
                                <Box
                                    key={carrier.id}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        borderRadius: 4,
                                        padding: "4px 12px 4px 4px",
                                        background: shipperColors.background,
                                        border: `1px solid ${shipperColors.streamrule}`,
                                    }}
                                >
                                    <Box sx={{ display: "flex", width: 24, height: 24, "& svg": { width: 24, height: 24 } }}>
                                        {getShipperLogo(carrier.type)}
                                    </Box>
                                    <Text bold sx={{ color: shipperColors.base }}>{carrier.name}</Text>
                                </Box>
                            );
                        })}
                    </Box>

                    {carriers.length === 0 && (
                        <Text light>{t("scanstatus_carriers_none")}</Text>
                    )}
                </Box>
            </Box>
        </ExplainerModal>
    );
}

export default EMScanStatus;
